import React from 'react';
import { connect } from 'react-redux';
import { MANAGE_ACCOUNT_LINK_EN, MANAGE_ACCOUNT_LINK_FR } from '../globals/settings';
import info from '../images/alertDB8843.png';

class ParentalAccessInfo extends React.Component {

    componentDidMount(){
        console.table(this.props)
        console.log(this.props.selectedLabResult);
    }
    componentDidUpdate(){
        console.log(this.props.selectedLabResult);
    }

    render() {
        return (
            <div className = "user-banner margin-16px">
                <div className="userIcon"><img src={info} width="20" /></div>
                <h5>{this.props.strings.PARENTAL_ACCESS_ALERT_HEADER}</h5>
                <br/>
                <p>{this.props.strings.PARENTAL_ACCESS_ALERT_BODY}
                    <strong>{this.props.strings.PARENTAL_ACCESS_ALERT_BODY_2}</strong>
                    {this.props.strings.PARENTAL_ACCESS_ALERT_BODY_3}
                    {this.props.strings.PARENTAL_ACCESS_ALERT_BODY_3_1}
                </p>
                
                <p>{this.props.strings.PARENTAL_ACCESS_ALERT_BODY_4}
                    <a style={{fontSize:"0.95rem", fontWeight:"bold"}} href={this.props.language === 'en' ? MANAGE_ACCOUNT_LINK_EN : MANAGE_ACCOUNT_LINK_FR} target="_blank">{this.props.strings.PARENTAL_ACCESS_ALERT_BODY_5}</a>
                    {this.props.strings.PARENTAL_ACCESS_ALERT_BODY_6}
                </p>
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        labResults: state.api.labResults,
        strings: state.language.strings,
        selectedLabResult: state.api.selectedLabResult,
        language: state.language.language,
    }
}

const ConnectedParentalAccessInfo = connect(
    mapStateToProps
)(ParentalAccessInfo);
export default ConnectedParentalAccessInfo;
